/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlatbedTowing40(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M22.7 8A2.15 2.15 0 0127 8v.85h4.358l2.175 11.482 1.514.83 3.058 1.675a2.545 2.545 0 011.325 2.235v8.75h-5.132a5.152 5.152 0 01-10.097 0H.05v-1.5h19.53V29.55H.65v-1.5h5.805a3.547 3.547 0 01-2.78-2.708l-19.224.028-.002-.75h-.75v-3.732c0-1.397.608-2.72 1.666-3.629l.002-.001 1.673-1.433.58-.498a6.333 6.333 0 016.323-5.98h7.249c1.304 0 2.529.637 3.277 1.705l1.905 2.72.866 1.237 6.152 1.323a5.328 5.328 0 014.207 5.208v3.782l-7.004.01a3.547 3.547 0 01-2.781 2.718H19.58V8.85h3.12V8zM10.6 23.832l5.5-.008v-2.189h-.723c-.715 0-1.42-.146-2.074-.425l-.52-.222-.231-.1.594-1.376.23.098c.138.06.324.14.514.22h.001c.47.201.975.305 1.486.305h.456a3.827 3.827 0 00-2.756-2.337l-6.35-1.365h-18.093l-.618.53-1.673 1.434a3.282 3.282 0 00-1.143 2.49v2.982l18.467-.027a3.544 3.544 0 016.933-.01zm-21.433-8.9H5.355l-.21-.3-1.905-2.719a2.503 2.503 0 00-2.048-1.065h-7.25a4.832 4.832 0 00-4.775 4.085zm31.913 17.39v-11.38h7.019v1.17h1.5v-5.617h-1.5v2.948h-7.02V10.35h9.037l2.075 10.957 2.135 1.17 3.06 1.676c.335.183.544.535.544.92v7.25h-3.552a5.15 5.15 0 00-10.256 0H21.08zM25.5 8.85h-1.3V8a.65.65 0 011.3 0v.85zm.1 23.95a3.65 3.65 0 117.3 0 3.65 3.65 0 01-7.3 0zM5.092 24.573a2.042 2.042 0 114.085 0 2.042 2.042 0 01-4.085 0z'
        />
      </g>
      <defs>
        <clipPath id='flatbed-towing-40_svg__clip0'>
          <path fill='#fff' d='M0 0h40v40H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgFlatbedTowing40;
